import { render, staticRenderFns } from "./ArmorClass.vue?vue&type=template&id=9262b7a6&scoped=true"
import script from "./ArmorClass.vue?vue&type=script&lang=js"
export * from "./ArmorClass.vue?vue&type=script&lang=js"
import style0 from "./ArmorClass.vue?vue&type=style&index=0&id=9262b7a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9262b7a6",
  null
  
)

export default component.exports